module.exports = __webpack_public_path__ + "img/measurement_info_back_elbow_right.2bf14199.jpg";